import { ComponentProps } from 'react';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatToast } from '@blocks-react/components/Toast';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { Conditional } from '../conditional';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import styles from './style.module.scss';

type CatToastProps = ComponentProps<typeof CatToast> & { message: string };
type ToastProps = {
  className?: string;
  onToastClose: () => void;
  toasts: CatToastProps[];
  delay: number;
  position?: {
    horizontalPosition?: 'center' | 'left' | 'right';
    verticalPosition?: 'top' | 'bottom';
  };
};

export const Toast = ({
  className,
  delay,
  onToastClose,
  toasts,
  position: { horizontalPosition = 'center', verticalPosition = 'top' } = {}
}: ToastProps) => {
  return (
    <CatToastGroup
      horizontalPosition={horizontalPosition}
      verticalPosition={verticalPosition}
      className={styles['toast-group__container']}
    >
      {toasts.map(({ key, variant, content, message }: CatToastProps) => {
        return (
          <div key={key}>
            <CatToast
              variant={variant}
              onBlToastClose={onToastClose}
              onBlToastCancel={onToastClose}
              delay={delay}
            >
              <div
                className={`${className} ${styles['toast-container__width']} d-flex`}
              >
                <Conditional test={variant === 'success'}>
                  <CatIconSuccess
                    className="me-3"
                    slot="after"
                    color="success"
                  />
                </Conditional>
                <Conditional test={variant === 'error'}>
                  <CatIconWarningCircle
                    className="me-2"
                    slot="after"
                    color="error"
                  />
                </Conditional>
                <Conditional test={variant === 'warning'}>
                  <CatIconWarningTriangle
                    className="me-2"
                    slot="after"
                    color="error"
                  />
                </Conditional>
                <div className="d-flex flex-column">
                  <CatHeading
                    data-testid={`cat-heading-${variant}`}
                    variant="label"
                  >
                    {message}
                  </CatHeading>
                  {content}
                </div>
              </div>
            </CatToast>
          </div>
        );
      })}
    </CatToastGroup>
  );
};
